import {
  Button,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { Alert } from "@material-ui/lab";
import { useChangeProfileMutation } from "../../../services/users/usersService";
import { useEffect } from "react";
import SuccessDialogBody from "../../../components/common/dialogs/SuccessDialogBody";

interface props {
  handleClose: () => void;
  refetch: () => void;
  idUser: number;
}

const ChangeProfileUserForm = ({ handleClose, refetch, idUser }: props) => {
  const [changeProfile, { isLoading, isSuccess, isError }] =
    useChangeProfileMutation();

  const schema = yup.object().shape({
    rol: yup.string().required("Perfil es requerido"),
  });

  const { getFieldProps, errors, touched, handleSubmit } = useFormik({
    initialValues: {
      rol: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      changeProfile({
        id_perfil: Number(values.rol),
        id_usuario: idUser,
      });
    },
  });

  useEffect(() => {
    isSuccess && refetch();
    // if (isSuccess) {
    //   refetch();
    //   // setTimeout(() => {
    //   //   handleClose();
    //   // }, 500);
    // }
  }, [isSuccess, refetch /* handleClose */]);

  if (isSuccess) {
    return (
      <SuccessDialogBody
        successMessage="Se cambio el perfil correctamente"
        handleClose={() => {
          handleClose();
        }}
      />
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <FormControl
          fullWidth
          variant="outlined"
          error={Boolean(errors.rol && touched.rol)}
        >
          <InputLabel id="filtro-label">Perfil</InputLabel>
          <Select
            labelId="filtro-label"
            label="Perfil"
            {...getFieldProps("rol")}
          >
            <MenuItem value={1}>Administrador</MenuItem>
            <MenuItem value={2}>Cliente</MenuItem>
          </Select>
          {Boolean(errors.rol && touched.rol) && (
            <FormHelperText>{errors.rol}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      {isSuccess && (
        <Grid item xs={12} md={12} lg={12}>
          <Alert severity="success">Se cambio el perfil correctamente.</Alert>
        </Grid>
      )}
      {isError && (
        <Grid item xs={12} md={12} lg={12}>
          <Alert severity="error">
            El servicio no esta disponible por el momento. Intente luego.
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} md={12} lg={12}>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            disabled={isLoading || isSuccess}
          >
            Guardar
          </Button>
        </DialogActions>
      </Grid>
    </Grid>
  );
};

export default ChangeProfileUserForm;
